<script>
    import { fade } from "svelte/transition"
    export let start
    export let switchAudio
    export let toggleEquation
    const play = () => {
        start()
        switchAudio()
    }
    const toggle = () => {
        toggleEquation()
        switchAudio()
    }
</script>

<style>

    #menu {
        display: flex;
    }

    #start-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    @media (max-width: 640px) {
        h1 {
            font-size: 1.2em;
        }
    }

</style>

<div id="start-wrapper" in:fade>
    <h1>ความรักของคุณคือสมการอะไร?</h1>
    <div id="menu">
        <button on:click={play}>เล่นควิซ</button>
        <button on:click={toggle}>รู้จักสมการ</button>
    </div>
    <!-- <div>
        <a href="https://www.youtube.com/watch?v=dJns4JQAKGI"><img src="assets/note.svg" id="icon" alt=""></a>
    </div> -->
</div>